import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { EntityModelDiargamWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;

require('../sass-main/pdc-widget-entity-model-dx-diagram.sass');
require('../../../_common/libs/dx25/css/dx.common.css');
require('../../../_common/libs/dx25/css/dx.light.css');
require('../../../_common/libs/dx25/css/dx-diagram.css');

export class EntityModelDiagramWidget extends WidgetBase {
    public static _name: string = 'Entity Model Diagram';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-entity-model-dx-diagram';
    public static icon: string = 'qrcode';
    public static namespace: string = 'business-intelligence';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-entity-model-dx-diagram'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(EntityModelDiagramWidget);

